module.exports = __webpack_public_path__ + "static/img/role-pt.230199c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/role-pt.png
// module id = KstA
// module chunks = 1